/* eslint-disable */
import services from 'services';
import axios from 'axios';
import * as types from './mutation-types';
import {ADAuthManager} from "@holdingblachere/js-sdk";

export default {
  loginWithUserToken: async ({ commit }, userToken) => {
    commit(types.LOGIN, { userToken: userToken });
    services.shopService.setUserToken(userToken);
  },
  loginUser: async ({ commit, rootGetters }, user) => {
    const alreadyLoggedInBefore = rootGetters['auth/currentUserId'];
    console.log('USER!!!', user);
    commit(types.LOGIN, { user });
  },
  loginWithCredentials: async ({ commit, dispatch, rootGetters }, { email, password }) => {
    // This authentication mode is only used for Portugal
    console.log('Authenticated', process.env.VUE_APP_ORGANIZATION);
    if (process.env.VUE_APP_ORGANIZATION === 'CDM_PRT') {
      const authUrl = process.env.VUE_APP_AUTH_URL;
      if (!authUrl) { throw new Error('MISSING VUE_APP_AUTH_URL in .env'); }
      const { data: { userInfo, token } } = await axios.post(authUrl, {
        email,
        password,
      });
      dispatch('loginUser', userInfo);
      dispatch('loginWithUserToken', token);
      return userInfo;
    }

    // This authentication method is used for others
    const auth = new ADAuthManager({ url: process.env.VUE_APP_MON_COMPTE_MB_BACKEND_URL });
    const { userInfo, token } = await auth.loginWithEmailAndPassword(email, password);
    dispatch('loginUser', userInfo);
    dispatch('loginWithUserToken', token);
    return userInfo;
  },
  logout: ({ commit, dispatch }) => {
    return services.authService.logout().then(() => {
      commit(types.LOGOUT);
    });
  },
  updateUser: async ({ commit }) => {
    const user = services.authService.currentUser();
    commit(types.UPDATE_USER, user);
  },
  fetchCurrentUserProfile: async ({ commit, getters }, userId) => {
    let currentUserId = userId;
    if (!currentUserId) {
      currentUserId = getters['currentUserId'];
    }
    console.log('currentUserId', currentUserId);
    const profile = await services.userService.getUser(currentUserId);
    commit('SET_USER_PROFILE', profile);
    return profile;
  },
};
